import { getLocalStorageItem, removeLocalStorageItem, setLocalStorageItem } from './local-storage';

export const AUTH_BLOCK_CODE_DEACTIVATED = 'account_deactivated';
const AUTH_BLOCK_CODE_KEY = 'protocolist-auth-block-code';
const AUTH_BLOCK_MESSAGE_KEY = 'protocolist-auth-block-message';
const AUTH_BLOCK_EVENT = 'protocolist-auth-block-changed';

export type AuthBlockState = {
  code: string;
  message: string;
};

const emitChange = () => {
  window.dispatchEvent(new Event(AUTH_BLOCK_EVENT));
};

export const getAuthBlockState = (): AuthBlockState | null => {
  const code = getLocalStorageItem(AUTH_BLOCK_CODE_KEY);
  const message = getLocalStorageItem(AUTH_BLOCK_MESSAGE_KEY);

  if (!code) {
    return null;
  }

  return {
    code,
    message: message || 'Ваш аккаунт деактивирован',
  };
};

export const setAuthBlockState = (state: AuthBlockState): void => {
  setLocalStorageItem(AUTH_BLOCK_CODE_KEY, state.code);
  setLocalStorageItem(AUTH_BLOCK_MESSAGE_KEY, state.message);
  emitChange();
};

export const clearAuthBlockState = (): void => {
  removeLocalStorageItem(AUTH_BLOCK_CODE_KEY);
  removeLocalStorageItem(AUTH_BLOCK_MESSAGE_KEY);
  emitChange();
};

export const subscribeToAuthBlockState = (listener: () => void): (() => void) => {
  window.addEventListener(AUTH_BLOCK_EVENT, listener);
  return () => window.removeEventListener(AUTH_BLOCK_EVENT, listener);
};
